import { useContext, useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { IoIosClose } from 'react-icons/io';

import Button from 'components/ui/button';
import { useModal } from 'context/ModalContext';
import Box from 'components/ui/box';

import FeedbackImg from 'assets/img/comportamento/bg-feedback-moedas.png';
import cardIcon from 'assets/img/card-plus.svg';

interface Props {
  onClose: () => void;
  onConfirm: () => void;
}

export default function ModalBonus({ onClose, onConfirm }: Props) {
  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={true}
        contentLabel="Avaliação"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 bg-black bg-opacity-60 flex flex-col items-center w-screen h-screen p-6 pt-[10vh] overflow-y-auto"
        contentElement={() => (
          <div className={`relative w-[324px]  border border-solid border-electric-blue bg-oxford-blue rounded-xl`}>
            <Button
              color="primary"
              className="absolute -right-5 -top-5 rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center z-10"
              onClick={() => {onClose()}}
            >
              <IoIosClose color="white" size={40} />
            </Button>

            <div className="mx-auto relative container overflow-y-auto overflow-x-hidden max-h-[85vh]">
              <div>
                <div className="mb-8 flex h-[80px] justify-center items-center space-x-2 bg-electric-blue rounded-t-xl">
                  <img className="w-10" src={cardIcon} alt="Icone com duas cartas" />
                  <h1 className="text-lg uppercase block text-center text-black font-bold">Reconhecer+</h1>
                </div>

                <div className="bg-maastricht-blue-3 rounded-lg mx-10 py-4 px-6 mb-5 text-center text-[12px] space-y-5 font-thin">
                  <p>Você está prestes a usar o seu Reconhecer+.</p>

                  <p>Deseja confirmar essa ação?</p>
                </div>

                <div className="flex justify-center mb-5">
                  <Button onClick={() => {onConfirm()}} color="primary" className="uppercase py-2 text-sm  min-w-[190px]">
                    Confirmar
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      />
    </>
  );
}
